import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import bg from '@assets/images/home_bg.webp';
export const HomeLayout = styled(Stack)(({theme:{spacing}}) => ({
  height: '100%',
  backgroundImage: `url(${bg})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  padding:`0 ${spacing(14)}`,
}));

